<template>
  <v-content>
    <v-item-group color="grey">
      <v-layout row wrap>
        <facts-header-item :value="breweries" label="Bryggerier" />
        <facts-header-item :value="beers" label="Öl" />
        <facts-header-item :value="fridays" label="Fredagar" />
      </v-layout>
    </v-item-group>
  </v-content>
</template>
<script>
import FactsHeaderItem from './FactsHeaderItem'

export default {
  components: {FactsHeaderItem},
  computed: {
    beers () {
      return this.$store.getters.beersCount
    },
    breweries () {
      return this.$store.getters.breweriesCount
    },
    fridays () {
      return this.$store.getters.fridaysCount
    }
  }
}
</script>
